import ContactsTable from "kinnect-front/FacilityMaintenance/Contacts/ContactsTable";
import FullWidthLayout from "@/layouts/FullWidthLayout";
import { FacilityMaintenanceContact } from "kinnect-models";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "FacilityMaintenanceContactsPage",

	metaInfo: { title: "Facility Maintenance - Contacts" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		contacts: [],
		search: ""
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_facility_maintenance_contacts" ) ) {
				return {
					icon: "add_circle",
					text: "Add Contact",
					to: { name: "facilityMaintenanceContactAdd" },
					tooltip: "Add a new facility maintenance contact"
				};
			}
		}
	},

	methods: {
		async fetchContacts() {
			this.contacts = await FacilityMaintenanceContact.get();
		},

		async fetch() {
			await this.fetchContacts();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<ContactsTable
					items={this.contacts}
					loading={this.$wait.is( "get contacts" )}
					search={this.search}
				></ContactsTable>
			</VCard>
		</FullWidthLayout>;
	}
};
